module.exports = __webpack_public_path__ + "static/media/new_loading.735bd216.gif";